import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';

export const DEVICE_INFO_HEADER = 'X-Reverb-Device-Info';

export function reverbDeviceInfoProperties(user, location = null) {
  const extraHeaders = location ? { pathname: location.pathname } : {};
  return {
    platform: user.deviceName,
    app_version: user.deviceAppVersion,
    platform_version: user.deviceOSVersion,
    ...extraHeaders,
  };
}

export function reverbDeviceInfoHeader(user: Partial<IUser>, location = null) {
  return {
    [DEVICE_INFO_HEADER]: JSON.stringify(reverbDeviceInfoProperties(user, location)),
  };
}
